import script from "./CrudSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrudSearch.vue?vue&type=script&setup=true&lang=ts"

import "./CrudSearch.vue?vue&type=style&index=0&id=b0c7dba2&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0c7dba2"]])

export default __exports__